var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.00005,
    height: 53.00029,
    viewBox: "0 0 55.00005 53.00029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.92581,20.13184c-.17676-.54102-.64453-.93506-1.20801-1.01758l-17.18262-2.52441L28.84768.8418c-.25098-.51514-.77441-.8418-1.34766-.8418s-1.09668.32666-1.34766.8418l-7.6875,15.74805L1.28225,19.11426c-.56348.08252-1.03125.47656-1.20801,1.01758-.17677.54102-.03223,1.13525.37305,1.53467l12.44336,12.2627-2.93848,17.31982c-.0957.56348.13672,1.13281.60059,1.46729.26074.18799.56836.28369.87793.28369.24121,0,.4834-.05811.7041-.17529l15.36523-8.16699,15.36426,8.16699c.50488.26807,1.11816.22705,1.58203-.1084.46387-.33447.69629-.90332.60059-1.46729l-2.9375-17.31982,12.44336-12.2627c.40527-.39941.5498-.99365.37305-1.53467Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.d404b7d3228126c4d561ab4402e09a66.svg";
export { ForwardRef as ReactComponent };